












import { Prop, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Delivery from '@/dto/deliveries/Delivery'
import TariffsTable from '@/components/delivery/tariffs/TariffsTable.vue'
import Tariff from '@/dto/deliveries/Tariff'
import TariffsService from '@/services/TariffsService'
@Component({
  components: { TariffsTable },
})
export default class Tariffs extends Vue {
  @Prop(Object)
  model: Delivery

  isPending: boolean = false
  tariffs: Tariff[] = []
  zoneNames: { [key: number]: string } | null = null

  updateTariffs(tariffs: Tariff[]) {
    this.tariffs = tariffs
  }

  @Watch('model', { immediate: true })
  loadTariffs() {
    this.isPending = true
    TariffsService.getTariffs(this.model.id as number)
      .then(({ tariffs, zoneNames }) => {
        this.tariffs = tariffs
        this.zoneNames = zoneNames
      })
      .finally(() => (this.isPending = false))
  }
}
